import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

function buildQueryString(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, value);
  });
  return query.toString();
}

export const LocationRequestsApi = createApi({
  reducerPath: "LocationRequests",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND3_URL}/location-requests`,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["LocationRequest"],
  endpoints: (builder) => ({
    getLocationRequests: builder.query({
      query: (params) => `?${buildQueryString(params)}`,
      providesTags: ["LocationRequest"],
    }),
    getLocationRequestDetails: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "LocationRequest", id }],
    }),
    confirmLocationRequest: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/${id}/confirm`,
        method: "PATCH",
        body: { comment },
      }),
      invalidatesTags: ["LocationRequest"],
    }),
    rejectLocationRequest: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/${id}/reject`,
        method: "PATCH",
        body: { comment },
      }),
      invalidatesTags: ["LocationRequest"],
    }),
  }),
});

export const {
  useGetLocationRequestsQuery,
  useGetLocationRequestDetailsQuery,
  useConfirmLocationRequestMutation,
  useRejectLocationRequestMutation,
} = LocationRequestsApi;
